(() => {
  if (window.themeRatingSnippets) return;

  const selector = '.ds-ruk_rating_snippet';
  const scriptUrl = 'https://widget.reviews.io/rating-snippet/dist.js';
  const cssUrl = 'https://widget.reviews.io/rating-snippet/dist.css';
  const watchedScripts = new WeakSet();
  let scheduled = false;

  function refresh() {
    scheduled = false;
    if (!document.querySelector(`${selector}:not([data-retrieved="true"]):not([data-pending])`)) return;

    if (typeof window.ratingSnippet === 'function') {
      window.ratingSnippet('ds-ruk_rating_snippet', {
        store: 'www.duschbrocken.de',
        mode: 'default',
        color: 'rgb(34, 158, 218)',
        linebreak: false,
        lang: 'de',
        showEmptyStars: false
      });
      return;
    }

    let script = Array.from(document.scripts).find(element => element.src === scriptUrl);
    if (script) {
      if (!watchedScripts.has(script)) {
        watchedScripts.add(script);
        script.addEventListener('load', scheduleRefresh, { once: true });
      }
      return;
    }

    if (!Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link => link.href === cssUrl)) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = cssUrl;
      document.head.appendChild(stylesheet);
    }
    script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.addEventListener('load', scheduleRefresh, { once: true });
    document.head.appendChild(script);
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(refresh, 0);
  }

  function start() {
    refresh();
    new MutationObserver(records => {
      const hasRatings = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ));
      if (hasRatings) scheduleRefresh();
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.themeRatingSnippets = { refresh: scheduleRefresh };
  window.addEventListener('load', scheduleRefresh, { once: true });
  document.addEventListener('shopify:section:load', scheduleRefresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
